import { render, staticRenderFns } from "./litedetails.vue?vue&type=template&id=48a63abc&scoped=true"
import script from "./litedetails.vue?vue&type=script&lang=js"
export * from "./litedetails.vue?vue&type=script&lang=js"
import style0 from "./litedetails.vue?vue&type=style&index=0&id=48a63abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a63abc",
  null
  
)

export default component.exports